(function () {
  'use strict';
  function convertDate(value) {
    var match = String(value || '').trim().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
    if (!match) return null;
    var month = Number(match[1]);
    var day = Number(match[2]);
    if (month < 1 || month > 12 || day < 1 || day > 31) return null;
    return String(day).padStart(2, '0') + '/' + String(month).padStart(2, '0') + '/' + match[3];
  }
  function localizeReviewDates(root) {
    var selector = '.jdgm-carousel-item__timestamp[data-time]';
    var scope = root || document;
    var nodes = [];
    if (scope.matches && scope.matches(selector)) nodes.push(scope);
    scope.querySelectorAll(selector).forEach(function (node) { nodes.push(node); });
    nodes.forEach(function (node) {
      if (node.dataset.id24FrenchDate === 'true') return;
      var formatted = convertDate(node.getAttribute('data-time'));
      if (!formatted) return;
      node.textContent = formatted;
      node.dataset.id24FrenchDate = 'true';
    });
  }
  function start() {
    localizeReviewDates(document);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) localizeReviewDates(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
